import { BusinessGroup } from 'components/search/utils';
import { findBusinessGroup } from 'components/search/businessGroups';
import { gql } from '@apollo/client';
import { useEffect } from 'react';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import { useFetchBusinessGroupLazyQuery } from 'generated/graphql';

export const BUSINESS_GROUP_QUERY = gql`
  query FetchBusinessGroup($businessGroupSlug: String!) {
    businessGroupBySlug(businessGroupSlug: $businessGroupSlug) {
      id
      ...BusinessGroup
    }
  }
  fragment BusinessGroup on BusinessGroupEntity {
    businesses {
      id
      name
    }
    id
    name
    groupLevelTags
    groupUrlPageTitle
    slug
  }
`;

export function useBusinessGroup(groupSlug?: string) {
  const isDynamicGroupUrlEnabled = useFeatureFlag('DYNAMIC_BUSINESS_GROUP_URL');
  const [fetchBusinessGroup, { data: businessGroupData, loading }] = useFetchBusinessGroupLazyQuery(
    {
      ssr: false,
    }
  );

  useEffect(() => {
    if (isDynamicGroupUrlEnabled && groupSlug && !loading && !businessGroupData) {
      fetchBusinessGroup({
        variables: { businessGroupSlug: groupSlug },
      });
    }
  }, [businessGroupData, fetchBusinessGroup, groupSlug, loading, isDynamicGroupUrlEnabled]);
  let businessGroup: BusinessGroup | undefined;
  if (groupSlug) {
    if (isDynamicGroupUrlEnabled && businessGroupData) {
      businessGroup = {
        id: businessGroupData?.businessGroupBySlug?.id,
        name: businessGroupData?.businessGroupBySlug?.groupUrlPageTitle,
        slug: businessGroupData?.businessGroupBySlug?.slug,
      } as BusinessGroup;
    } else {
      businessGroup = findBusinessGroup(groupSlug);
    }
  }

  return businessGroup;
}
